import ReactECharts from "echarts-for-react";

export default function NightingaleChart({ data }) {
  const options = {
    title: {
      text: "Top 5 Dealers",
      left: "left",
      textStyle: {
        fontFamily: "Uni Neue",
        fontSize: 16,
        fontWeight: "600",
      },
    },
    legend: {
      top: "bottom",
      show: false,
    },
    tooltip: {
      trigger: "item",
      formatter: "{a} <br/>{b} : {c} ({d}%)",
    },
    label: {
      show: true,
      formatter: "{b}({c})",
    },
    series: [
      {
        name: "Top 5 Dealers",
        type: "pie",
        radius: [20, 60],
        center: ["50%", "50%"],
        roseType: "radius",
        itemStyle: {
          borderRadius: 5,
        },
        data: data,
      },
    ],
  };

  return <ReactECharts option={options} style={{ height: 240 }} />;
}
